import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { checkCBSEGr8 , checkIfNonScienceSubjectExists} from '@app-helpers/functions';
import { UserService } from '@app-services/user/user.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { UtilityService } from 'src/app/core/services/utility.service';

@Component({
  selector: 'app-course-list-card',
  templateUrl: './course-list-card.component.html',
  styleUrls: ['./course-list-card.component.css']
})
export class CourseListCardComponent implements OnInit {
  @Input() type: any;
  @Input() courseData: any;
  @Input() dataType: any;
  @Output() refreshData: EventEmitter<any> = new EventEmitter<any>();

  public isOnGoing: boolean = false;
  public isCompleted: boolean = false;
  public isUpcomming: boolean = false;
  public isStartTomrrow: boolean = false;
  public waitingDays: number = 0;

  public completationPercentage: number = 0;

  public circleBarRadius: any = 51.5;
  public circleBarTitleFontSize: any = 20;

  public isResponsiveView: boolean = false;

  public errImgTry: number = 0;
  public errImgMaxTry: number = 5;

  public userTypeId: number = 1;
  params: any;
  showScience: boolean = false;

  constructor(
    public _helper: HelperService,
    public userService: UserService,
    public route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    console.log('CourseData: ', this.courseData);
    this.setircleProgressBarResolution();
    this.checkStatus();
    this.params = {...(this.route?.snapshot?.queryParams || {})};
    this.userTypeId = this.userService.getUserType();
    this.showScience = checkCBSEGr8();
  }

  checkStatus = () => {
    this.isOnGoing = UtilityService.isOnGoing(this.courseData?.schedule);
    this.isUpcomming = UtilityService.isUpcomming(this.courseData?.schedule?.startDate, this.courseData?.schedule?.serverTime);
    this.isCompleted = UtilityService.isCompleted(this.courseData?.schedule?.endDate, this.courseData?.schedule?.serverTime);
    this.isStartTomrrow = UtilityService.isTomorrow(this.courseData?.schedule?.startDate, this.courseData?.schedule?.serverTime);
    this.waitingDays = UtilityService.getWaitingDays(this.courseData?.schedule?.startDate, this.courseData?.schedule?.serverTime);

    if(this.isOnGoing) {
      this.completationPercentage = this.randomInteger(10, 90);
    } else if (this.isCompleted) {
      this.completationPercentage = 100;
    } else {
      this.completationPercentage = 0
    }
  }

  getClassStatusText = ():any => {
    if(this.isOnGoing) {
      return 'Ongoing'
    } else if(this.isStartTomrrow) {
      return 'Starts tomorrow'
    } else if(this.isUpcomming) {
      return 'Starts in ' + this.waitingDays + ' days';
    } else if(this.isCompleted) {
      return 'Completed';
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.setircleProgressBarResolution();
  }

  setircleProgressBarResolution = () => {
    if (window.innerWidth < 768) {
      this.isResponsiveView = true;

      this.circleBarRadius = 30;
      this.circleBarTitleFontSize = 13;
    } else {
      this.isResponsiveView = false;

      this.circleBarRadius = 51.5;
      this.circleBarTitleFontSize = 14;
    }
  }

  getTeacherDetails = (_teacher:any = null, _key: string = 'name') => {
    if(_teacher) {
      return _teacher[_key];
    } else {
      if(_key == 'profileImage') {
        return '/assets/img/teacher-placeholder.png'
      } else {
        return '';
      }
    }
  }

  toLowerCase = (_sub:any = null) => {
    if(typeof _sub === 'string') {
      return _sub.toLowerCase();
    } else {
      return '';
    }
  }

  randomInteger = (min:number=0, max:number=99) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  checkIfNonScienceSubjectExists(subjects){
    return checkIfNonScienceSubjectExists(subjects);
 }
}
